import React, { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../conexoes/api'
import '../../css/painelAutomacao/tabelaAutomacao.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  mudarPermissaoElementoAcao,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarDesabilitarRegra,
  revelarExcluirRegra,
  revelarHabilitarRegra
} from '../../redux/actions/index'
import { useGlobal } from '../../stores/useGlobal.js'
import { validadorPermissaoElemento } from '../../utils/verificadorPermissaoElemento'
import MensagemErro from '../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../componentesModais/mensagens/mensagemSucesso'
import Table from '../Table/index.jsx'

import EditarRegra from './editarRegra/editarRegra'
import NovaRegra from './novaRegra/novaRegra'

const valorLimite = 50
let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0

const TableprimaryKey = 'cd_aut_regra'

function TabelaAutomacao() {
  const { setIsLoadingGlobal } = useGlobal()

  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(0)

  const [cdAcao, setCdAcao] = useState([])
  const [cdRegraAcao, setCdRegraAcao] = useState([])
  const [flAtivoRegraAcao, setFlAtivoRegraAcao] = useState([])
  const [cdUsuario, setCdUsuario] = useState()
  const [dsParametro, setDsParametro] = useState()
  const [cdAutEvento, setCdAutEvento] = useState()
  const [dsAutEvento, setDsAutEvento] = useState()
  const [cdAutEventoParametro, setCdAutEventoParametro] = useState()
  const [cdAutEventoParametroValor, setCdAutEventoParametroValor] = useState()
  const [dsValor, setDsValor] = useState()
  const [cdAutRegra, setCdAutRegra] = useState()
  const [cdAutRegraNivel, setCdAutRegraNivel] = useState()
  const [cdAutRegraParametroValor, setCdAutRegraParametroValor] = useState()
  const [cdAutRegraUsuario, setCdAutRegraUsuario] = useState()
  const [flParametro, setFlParametro] = useState()

  const [mensagemErro, setMensagemErro] = useState('')
  const [mensagemSucesso, setMensagemSucesso] = useState('')
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState()

  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )

  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarNovaRegra = useSelector(
    (state) => state.automacaoState.revelarNovaRegra
  )
  let revelarEditarRegra = useSelector(
    (state) => state.automacaoState.revelarEditarRegra
  )
  let revelarExcluirRegraHook = useSelector(
    (state) => state.automacaoState.revelarExcluirRegra
  )
  let revelarHabilitarRegraHook = useSelector(
    (state) => state.automacaoState.revelarHabilitarRegra
  )
  let revelarDesabilitarRegraHook = useSelector(
    (state) => state.automacaoState.revelarDesabilitarRegra
  )
  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )

  const [spinAtivo, setSpinAtivo] = useState(true)
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  const despacho = useDispatch()

  const queryClient = useQueryClient()

  useQuery(
    ['regras-automacao', paginaAtual, filtros, conteudoBusca, renderizar],
    async () => {
      setIsLoadingGlobal(true)
      const valorLimite = 50
      let contador = (paginaAtual - 1) * valorLimite

      if (
        conteudoBusca &&
        (filtros.vazio === 'vazio' || filtros.vazio === undefined)
      ) {
        const { data } = await api_gateway.get(
          `/m1/consultar/aut_regra?paginaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}`
        )
        return data
      } else if (!filtros.vazio && filtros.vazio !== undefined) {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          filtros
        }

        const { data } = await api_gateway.post('/m1/filtrar/aut_regra', dados)
        return data
      } else {
        const { data } = await api_gateway.get(
          `/m1/consultar/aut_regra?paginaAtual=${contador}&carregarLimit=${valorLimite}`
        )
        return data
      }
    },
    {
      onSuccess: async (data) => {
        contador = (paginaAtual - 1) * valorLimite

        const novosItens = []

        data?.dados?.forEach((regra, index) => {
          novosItens[contador + index] = regra
        })

        await contarItens()

        setItens(novosItens)

        setIsLoadingGlobal(false)
      },
      onError: (error) => {
        console.error(error)
        if (error?.message) {
          setMensagemErro(error.message)
          setRevelarMensagemErro(true)
        }

        setIsLoadingGlobal(false)
      },
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  )

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('moduloAutomacao'))

    async function carregarTabela() {
      // limpa e reseta como antes
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      setSpinAtivo(false)
    }

    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(501) // 'painelAutomacaoTabelaAutomacao'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function handlerVerificarPermissaoAcao() {
      despacho(
        mudarPermissaoElementoAcao(
          !(await validadorPermissaoElemento(
            permissaoElemento,
            'veye/automacao/acoes'
          ))
        )
      )
    }
    handlerVerificarPermissaoAcao()
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissaoElemento])

  const colunas = [
    {
      dataField: 'cd_aut_regra',
      headerClasses: 'nao-selecionavel',
      text: 'Cód. Regra',
      hidden: true,
      formatter: (cell, row) => {
        return (
          <p
            className={
              row?.FL_ATIVO_REGRA == 0
                ? 'fonte-cor-7 label-tabela-1'
                : 'fonte-cor-1 label-tabela-1'
            }
          >
            {cell || '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_aut_evento',
      headerClasses: 'nao-selecionavel',
      text: 'Regra',
      sort: true,
      formatter: (cell, row) => {
        return (
          <p
            className={
              row?.FL_ATIVO_REGRA == 0
                ? 'fonte-cor-7 label-tabela-1'
                : 'fonte-cor-1 label-tabela-1'
            }
          >
            {cell || '-'}
          </p>
        )
      }
    },
    {
      dataField: 'PARAMETRO',
      headerClasses: 'nao-selecionavel',
      text: 'Parâmetro',
      sort: true,
      formatter: (cell, row) => {
        return (
          <p
            className={
              row?.FL_ATIVO_REGRA == 0
                ? 'fonte-cor-7 label-tabela-1'
                : 'fonte-cor-1 label-tabela-1'
            }
          >
            {cell || '-'}
          </p>
        )
      }
    },
    {
      dataField: 'cd_aut_regra_nivel',
      headerClasses: 'nao-selecionavel',
      text: 'Nível',
      sort: true,
      formatter: (cell, row) => {
        if (cell === 3) {
          return (
            <div className="tabela-automacao-container-esfera">
              <div className="tabela-automacao-esfera-verde" />
              <p
                className={
                  row?.FL_ATIVO_REGRA == 0
                    ? 'fonte-cor-7 label-tabela-1'
                    : 'fonte-cor-1 label-tabela-1'
                }
              >
                Normal
              </p>
            </div>
          )
        } else if (cell === 2) {
          return (
            <div className="tabela-automacao-container-esfera">
              <div className="tabela-automacao-esfera-amarela" />
              <p
                className={
                  row?.FL_ATIVO_REGRA == 0
                    ? 'fonte-cor-7 label-tabela-1'
                    : 'fonte-cor-1 label-tabela-1'
                }
              >
                Atenção
              </p>
            </div>
          )
        } else if (cell === 1) {
          return (
            <div className="tabela-automacao-container-esfera">
              <div className="tabela-automacao-esfera-vermelha" />
              <p
                className={
                  row?.FL_ATIVO_REGRA == 0
                    ? 'fonte-cor-7 label-tabela-1'
                    : 'fonte-cor-1 label-tabela-1'
                }
              >
                Urgente
              </p>
            </div>
          )
        } else {
          return (
            <div className="tabela-automacao-container-esfera">
              <div className="tabela-automacao-esfera-cinza" />
              <p
                className={
                  row?.FL_ATIVO_REGRA == 0
                    ? 'fonte-cor-7 label-tabela-1'
                    : 'fonte-cor-1 label-tabela-1'
                }
              >
                -
              </p>
            </div>
          )
        }
      }
    },
    {
      dataField: 'ACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Forma de envio',
      sort: true,
      formatter: (cell, row) => {
        return (
          <p
            className={
              row?.FL_ATIVO_REGRA == 0
                ? 'fonte-cor-7 label-tabela-1'
                : 'fonte-cor-1 label-tabela-1'
            }
          >
            {cell || '-'}
          </p>
        )
      }
    }
  ]

  function handleSelecionarRegra(row) {
    ColetaClickstream(506) // 'painelAutomacaoTabelaAutomacaoHandleSelecionarRegra'
    let codigosAcao = []
    row.CD_ACAO.split(',').map((item) => {
      codigosAcao.push(item)
    })
    let codigosRegraAcao = []
    row.CD_REGRA_ACAO.split(',').map((item) => {
      codigosRegraAcao.push(item)
    })
    let flagRegraAcao = []
    row?.FL_ATIVO_REGRA_ACAO.split(',').map((item) => {
      flagRegraAcao.push(item)
    })
    setCdAcao(codigosAcao)
    setCdRegraAcao(codigosRegraAcao)
    setFlAtivoRegraAcao(flagRegraAcao)
    setCdUsuario(row.CD_USUARIO)
    setDsParametro(row.PARAMETRO)
    setCdAutEvento(row.cd_aut_evento)
    setDsAutEvento(row.ds_aut_evento)
    setCdAutEventoParametro(row.cd_aut_evento_parametro)
    setCdAutEventoParametroValor(row.cd_aut_evento_parametro_valor)
    setDsValor(row.ds_valor)
    setCdAutRegra(row.cd_aut_regra)
    setCdAutRegraNivel(row.cd_aut_regra_nivel)
    setCdAutRegraParametroValor(row.cd_aut_regra_parametro_valor)
    setCdAutRegraUsuario(row.cd_aut_regra_usuario)
    setFlParametro(parseInt(row.fl_parametro))
    despacho(desabilitarAcoes(false))
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual && filtros.vazio) {
      apiData = await api_gateway.get(
        '/m1/consultar/aut_regra?buscar=' + conteudoBusca + '&contar=true'
      )
    } else {
      const dados = {
        paguinaAtual: contador,
        carregarLimit: valorLimite,
        filtros: filtros,
        contar: true
      }
      apiData = await api_gateway.post('/m1/filtrar/aut_regra', dados)
    }
    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    despacho(desabilitarAcoes(true))
    setPaginaAtual(1)
  }

  function handleExcluirRegra() {
    setSpinAtivo(true)

    api_gateway
      .get(`/m1/deletar/aut_regra?cd_aut_regra=${cdAutRegra}`)
      .then(() => {
        setMensagemSucesso('Regra deletada')
        setRevelarMensagemSucesso(true)
        despacho(revelarExcluirRegra(false))

        queryClient.invalidateQueries('regras-automacao')
      })
      .catch((error) => {
        setMensagemErro(error.response?.data?.info)
        setRevelarMensagemErro(true)
      })
      .finally(() => {
        setSpinAtivo(false)
      })
  }

  useEffect(() => {
    if (cdAutRegra > 0) {
      setSpinAtivo(true)

      handleExcluirRegra()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarExcluirRegraHook])

  async function handleDesabilitarRegra() {
    await api_gateway
      .post('/m1/alterar/aut_regra/aut_regra_normal', {
        dados: {
          fl_ativo: '0'
        },
        condicao: {
          cd_aut_regra: cdAutRegra
        }
      })
      .then(function () {
        setMensagemSucesso('Regra desabilitada')
        setRevelarMensagemSucesso(true)
        despacho(revelarDesabilitarRegra(false))
        setRenderizar(!renderizar)
        setSpinAtivo(false)
      })
      .catch(function (error) {
        despacho(revelarDesabilitarRegra(false))
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
        setSpinAtivo(false)
      })
  }

  useEffect(() => {
    if (cdAutRegra > 0) {
      setSpinAtivo(true)

      handleDesabilitarRegra()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarDesabilitarRegraHook])

  async function handleHabilitarRegra() {
    await api_gateway
      .post('/m1/alterar/aut_regra/aut_regra_normal', {
        dados: {
          fl_ativo: '1'
        },
        condicao: {
          cd_aut_regra: cdAutRegra
        }
      })
      .then(function () {
        setMensagemSucesso('Regra habilitada')
        setRevelarMensagemSucesso(true)
        despacho(revelarHabilitarRegra(false))
        setRenderizar(!renderizar)
        setSpinAtivo(false)
      })
      .catch(function (error) {
        despacho(revelarHabilitarRegra(false))
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
        setSpinAtivo(false)
      })
  }

  useEffect(() => {
    if (cdAutRegra > 0) {
      setSpinAtivo(true)

      handleHabilitarRegra()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarHabilitarRegraHook])

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)
      handleSelecionarRegra(row)
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <div className="container-tela">
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={() =>
                setRevelarMensagemSucesso(!revelarMensagemSucesso)
              }
              mensagemTitulo="Sucesso"
              mensagemParagrafo1={mensagemSucesso}
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1="Ocorreu um erro. Tente novamente mais tarde."
              mensagemParagrafo2="Caso o erro persista, entre em contato com o Suporte."
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarNovaRegra === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <NovaRegra setRenderizar={setRenderizar} renderizar={renderizar} />
          </div>
        </div>
      )}
      {revelarEditarRegra === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <EditarRegra
              cdAcao={cdAcao}
              cdRegraAcao={cdRegraAcao}
              flAtivoRegraAcao={flAtivoRegraAcao}
              cdUsuario={cdUsuario}
              dsParametro={dsParametro}
              cdAutEvento={cdAutEvento}
              dsAutEvento={dsAutEvento}
              cdAutEventoParametro={cdAutEventoParametro}
              cdAutEventoParametroValor={cdAutEventoParametroValor}
              dsValor={dsValor}
              cdAutRegra={cdAutRegra}
              cdAutRegraNivel={cdAutRegraNivel}
              cdAutRegraParametroValor={cdAutRegraParametroValor}
              cdAutRegraUsuario={cdAutRegraUsuario}
              renderizar={renderizar}
              flParametro={flParametro}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
export default connect(mapStateToProps)(React.memo(TabelaAutomacao))
